export default __webpack_public_path__ + "static/media/sap.6aa11d5e.png";